import {VmIcons, VmView, VmButton, VmInput, VmSpinner} from 'components'
import {Fragment, useEffect, useState} from 'react'
import {isFunction} from 'utils'
import {mSearchCustomers} from './api'

export default function SearchCustomers(props) {
  const title = 'Pilih Pelanggan',
    iconTitle = 'VmUserIcon',
    placeholder = 'Cari Data Pelanggan',
    limit = 10
  const [ckeyword, setCkeyword] = useState('')
  const [customers, setCustomers] = useState([])
  const [cloading, setCloading] = useState(true)
  const [cerror, setCerror] = useState(false)
  const [page, setpage] = useState(1)
  const [loadmoreitems, setloadmoreitems] = useState(true)
  const [onloadmoreitems, setonloadmoreitems] = useState(false)
  const firstLoad = () => {
    setCloading(true)
    setCerror(false)
    setpage(1)
    return onLoadData(1)
  }
  const reset = () => {
    setCkeyword('')
  }
  const onClose = () => {
    if (isFunction(props?.close)) {
      props.close()
    }
  }
  const onSelect = data => {
    if (isFunction(props?.select)) {
      props.select(data)
      if (isFunction(props?.close)) {
        props.close()
      } else {
        console.warn('Modala not closed')
      }
    }
  }
  const onLoadData = (page = 1) => {
    var offset = page
    if (page > 1) {
      offset -= 1
      offset *= limit
    } else {
      offset = 0
    }
    mSearchCustomers({
      input: {...props.input, pasnama: ckeyword, limit, offset: offset},
    })
      .then(({statusCode, data}) => {
        if (statusCode === 200 && data.data) {
          if (data.data.length < limit) {
            setloadmoreitems(false)
            setonloadmoreitems(false)
          } else {
            setloadmoreitems(true)
            setonloadmoreitems(false)
          }
          if (page > 1) {
            setCustomers([...customers, ...data.data])
          } else {
            setCustomers(data.data)
          }
          setCerror(false)
        } else {
          setloadmoreitems(false)
          setonloadmoreitems(false)
          setCustomers([])
        }
      })
      .catch(err => {
        // console.error('err', err)
        setloadmoreitems(false)
        setCerror(err?.data?.message || 'Gagal mengambil data pelanggan!')
      })
      .finally(() => {
        setCloading(false)
        setonloadmoreitems(false)
      })
  }
  const onEndReachedCost = etbodytablecost => {
    const isBottom =
      etbodytablecost?.getBoundingClientRect()?.bottom <= window.innerHeight
    if (isBottom && loadmoreitems && !onloadmoreitems) {
      setonloadmoreitems(true)
      setpage(page + 1)
      return onLoadData(page + 1)
    }
  }
  const onScrollCapture = e => {
    const {id, children} = e.target
    if (id === 'SearchCustomerContents') {
      return onEndReachedCost(children[children.length - 1])
    }
  }
  const onChangeCaptureInput = e => {
    const {value} = e.target
    setCkeyword(value)
  }
  const onKeyDownCaptureInput = e => {
    const {keyCode} = e
    if (keyCode === 13) {
      firstLoad()
    }
  }
  useEffect(() => {
    firstLoad()
    return () => {}
  }, [])

  return (
    <Fragment>
      <VmView className="flex flex-row relative items-center mb-4 w-[-webkit-fill-available]">
        {/* Icon */}
        <VmIcons
          className="text-black2-payment"
          variant="outline"
          style={{strokeWidth: '0.18rem'}}
          name={iconTitle}
          size={16}
        />
        {/* Title */}
        <VmView className="ml-2 !text-black2-payment text-sm font-semibold">
          {title}
        </VmView>
      </VmView>
      {/* Search Bar */}
      <VmView className="flex flex-row mb-4 shadow-md rounded-full !min-h-[2.3rem] overflow-hidden">
        <VmView className="relative flex flex-row bg-white overflow-x-hidden !w-[-webkit-fill-available]">
          <VmInput
            typeInput="text"
            className="absolute !text-xs !w-[-webkit-fill-available] !h-[-webkit-fill-available] border-0"
            hidering={true}
            placeholder={placeholder}
            onChangeCapture={onChangeCaptureInput}
            onKeyDownCapture={onKeyDownCaptureInput}
            value={ckeyword}
          />
          {ckeyword?.length > 0 && (
            <VmView
              onClick={reset}
              className="absolute flex items-center top-0 right-0 bottom-0 mr-2"
            >
              <VmIcons
                size={16}
                name="VmXCircleIcon"
                variant="outline"
                className="text-red5-payment"
              />
            </VmView>
          )}
        </VmView>
        <VmButton
          className="flex justify-center !flex-none p-3 !rounded-l-none !min-w-[50px] !bg-blue1-payment"
          hidering={true}
          onClick={firstLoad}
        >
          <VmIcons size={14} name="VmMagnifyingGlassIcon" color="#FFFFFF" />
        </VmButton>
      </VmView>
      {/* Contents */}
      <VmView
        id="SearchCustomerContents"
        onScrollCapture={onScrollCapture}
        className="flex relative flex-col overflow-x-hidden overflow-y-scroll h-[-webkit-fill-available] mb-4"
      >
        {cloading ? (
          <VmSpinner className="self-center text-sky-500" />
        ) : cerror ? (
          <VmView className="self-center text-sm">{cerror}</VmView>
        ) : customers?.length === 0 ? (
          <VmView className="self-center text-sm">
            {'Belum ada data pelanggan!'}
          </VmView>
        ) : (
          customers.map((im, index) => {
            const isvmedis = im?.pasbbm && im?.pasbbm !== '0'
            if (!im?.pasnama?.length) {
              return <Fragment key={`con-${index}`} />
            }
            return (
              <Fragment key={`con-${index}`}>
                <VmView className="relative flex flex-col mb-4 p-2 bg-white rounded-xl border border-[#F4F4F4]">
                  {/* Title */}
                  <VmView className="!text-black2-payment text-sm">
                    {im?.pasnama || ''}
                  </VmView>
                  {/* Subtitle */}
                  <VmView className="!text-[#A1A1A1] text-xs mb-2">
                    {im?.pasrm || ''}
                  </VmView>
                  {/* Description */}
                  <VmView className="!text-[#6A6A6A] text-xs mb-2">
                    {im?.pasalamat || ''}
                  </VmView>
                  {/* Footers */}
                  <VmView className="flex flex-row justify-between items-center">
                    <VmView className="!text-[#A1A1A1] text-xs">
                      {im?.pastelp || ''}
                    </VmView>
                    <VmButton
                      className="flex justify-center !flex-none p-1 !rounded-full !min-w-[60px] !bg-blue1-payment text-xs"
                      hidering={true}
                      onClick={() => onSelect(im)}
                    >
                      Pilih
                    </VmButton>
                  </VmView>
                  {/* Header Button */}
                  <VmView className="absolute top-2 right-2 flex flex-row items-center">
                    {isvmedis && (
                      <VmButton
                        className="flex justify-center !flex-none mr-2 p-1 !rounded-full !bg-blue1-payment text-xs"
                        hidering={true}
                      >
                        <VmIcons
                          size={12}
                          name="VmVmedisIcon"
                          variant="abstract"
                        />
                      </VmButton>
                    )}
                    <VmButton
                      className="flex justify-center !flex-none p-1 !rounded-full !bg-blue1-payment text-xs"
                      hidering={true}
                    >
                      <VmIcons
                        size={12}
                        name="VmBuildingStorefrontIcon"
                        variant="outline"
                        color="#FFFFFF"
                      />
                    </VmButton>
                  </VmView>
                </VmView>
                {index + 1 === customers.length && (
                  <VmView className="relative flex flex-col mb-4 p-2 bg-white items-center text-stone-600 text-xs">
                    {onloadmoreitems ? (
                      <VmSpinner className="self-center text-sky-500" />
                    ) : (
                      '  '
                    )}
                  </VmView>
                )}
              </Fragment>
            )
          })
        )}
      </VmView>
      {/* Footers */}
      <VmView className="flex flex-row justify-between">
        <VmButton
          className="flex justify-center w-[-webkit-fill-available] !flex-none p-2 !rounded-xl !bg-red5-payment text-xs"
          hidering={true}
          onClick={onClose}
        >
          Batal
        </VmButton>
      </VmView>
    </Fragment>
  )
}
